<template>
  <ShopifyStockAdd v-if="SHOPIFYBRANDS.includes(BRAND)"></ShopifyStockAdd>
  <OpenCartStockAdd v-else></OpenCartStockAdd>
</template>

<script>
import { ShopifyStockAdd, OpenCartStockAdd } from "./partials";
export default {
  name: "stock-add",
  components: { ShopifyStockAdd, OpenCartStockAdd }
};
</script>
